import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Parite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      random: Math.floor(Math.random() * 6),
      operationTab: [
        "Pair + Pair",
        "Pair + Impair",
        "Impair + Impair",
        "Pair x Pair",
        "Pair x Impair",
        "Impair x Impair",
      ],
      resTab: ["P", "I", "P", "P", "P", "I"],
      answer: "",
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerParite = (event) => {
    event.preventDefault();
    var good = this.state.resTab[this.state.random];
    if ((this.state.answer).toUpperCase() === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.operationTab[this.state.random] +
          " = " +
          this.state.resTab[this.state.random],
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.operationTab[this.state.random] +
          " = " +
          this.state.resTab[this.state.random],
      });
    }
    var rand = Math.floor(Math.random() * 6);
    this.setState({ random: rand, answer: "" });
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">Parité</h2>
          </div>
        </div>

        <div className="container">
          <p>
            Repondez "P" si le resultat est pair ou "I" si le resultat est
            impair.{" "}
          </p>
          <p className={this.state.messageColor}>{this.state.message}</p>
          <form
            className="col"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={this.mySubmitHandlerParite}
          >
            <label className="label-exos">
              {this.state.operationTab[this.state.random]} ={" "}
            </label>
            <div className="row" style={{ alignItems: "baseline" }}>
              <input
                className="input-number"
                type="text"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
            </div>
            <input
              className="validate-button"
              style={{ backgroundColor: "#00cfa4" }}
              type="submit"
              value="Valider"
            />
          </form>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col-12 col-lg-4">
            <a className="all-button" href="/">
              Retour au menu
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Parite;
